import * as React from "react"
const SvgUploadFile = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 17.571v-3.175l-.875.875q-.3.3-.7.288a1.06 1.06 0 0 1-.7-.288 1 1 0 0 1-.313-.7.92.92 0 0 1 .288-.7l2.6-2.6q.15-.15.325-.212.175-.063.375-.063c.2 0 .258.021.375.063a.9.9 0 0 1 .325.212l2.6 2.6q.3.3.287.7-.012.4-.287.7a1.04 1.04 0 0 1-.688.313.85.85 0 0 1-.374-.063 1 1 0 0 1-.338-.225l-.9-.9v3.175a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713" />
    <path
      fillRule="evenodd"
      d="M4.588 21.984q.587.587 1.412.587h12q.824 0 1.413-.587A1.93 1.93 0 0 0 20 20.571V9.396a1.98 1.98 0 0 0-.575-1.4l-4.85-4.85a1.98 1.98 0 0 0-1.4-.575H6q-.824 0-1.412.588A1.93 1.93 0 0 0 4 4.57v16q0 .825.588 1.413ZM13 4.57v4a.97.97 0 0 0 .287.713q.288.287.713.287h4v11H6v-16z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgUploadFile
